// Translations
import landing from '../views/landing/translations/en'

// Translation: Error (English)
export default Object.freeze({
	name: 'Error',
	views: { landing }
})
